import objectionTrackActions from "./actions";

const initialState = {

    objectionCourses : [],
    objectionDetails : [],

    objCredential : [],
    objQuestionsData : [],


 };

const objectionTrackerReducer = (state = initialState, action) => {
  switch (action.type) {
    
        case objectionTrackActions.SET_OBJECTION_COURSES:
          return {
            ...state,
            objectionCourses: action.payload,
          };


          case objectionTrackActions.SET_CANDIDATE_OBJECTION_DETAILS:
            return {
              ...state,
              objectionDetails: action.payload,
            };

            case objectionTrackActions.SET_OBJ_CREDENTIAL:
            return {
              ...state,
              objCredential: action.payload,
            };

            case objectionTrackActions.SET_OBJ_QUESTIONS:
            return {
              ...state,
              objQuestionsData: action.payload,
            };
         
           
            
    default:
      return state;
  }
};

export default objectionTrackerReducer;
